var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 ma-md-5 mx-lg-12"},[_c('v-row',{class:[
      'mx-2 align-center',
      {
        'flex-column justify-center': !_vm.$vuetify.breakpoint.mdAndUp,
      },
    ],attrs:{"no-gutters":""}}),[_c('v-row',{staticClass:"titleMobile",style:({gap: '1rem'})},[_c('v-btn',{staticClass:"back",attrs:{"dark":"","icon":"","to":"/configuration"}},[_c('v-icon',{style:({color: '#27846d !important', fontSize: '34px'})},[_vm._v(" icon-ayudadigital-volver ")])],1),_c('h2',[_vm._v(" "+_vm._s(_vm.$t('views.configuration.applications.title'))+" ")])],1),_c('div',{staticClass:"plantillaSuscrip"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ApplicationConfiguration',{attrs:{"applications":_vm.applications}})],1)],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }